import { render, staticRenderFns } from "./Breakdown.vue?vue&type=template&id=018f3d7c&scoped=true&"
import script from "./Breakdown.vue?vue&type=script&lang=ts&"
export * from "./Breakdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018f3d7c",
  null
  
)

export default component.exports